<template>
  <div class="study-prove-wrapper">
    <div class="zhanwei4"></div>

    <div class="prove-container-card">
      <el-tabs v-model="activeName" class="modern-tabs">
        <!-- Tab 1: 游学结业证明 -->
        <el-tab-pane label="研学 / 游学证明证书" name="first">
          <div class="tab-pane-content">
            <!-- 顶部引导与规范说明 -->
            <div class="prove-header-bar">
              <div class="header-left">
                <span class="indicator-bar"></span>
                <div>
                  <h3 class="header-title">研学结业证书底图配置</h3>
                  <p class="header-desc">
                    通关后玩家可领取的数字荣誉证书底图，支持 App
                    端实时压印姓名与通关日期
                  </p>
                </div>
              </div>
              <div class="header-right">
                <span class="ratio-badge">推荐比例 9:16 或 A4竖版 (≤5MB)</span>
              </div>
            </div>

            <!-- 主内容展示区：左侧真机/证书拟物展台，右侧规格与快捷上传 -->
            <div class="certificate-layout">
              <!-- 左侧：证书卡片展台 -->
              <div class="certificate-stage">
                <div class="cert-frame-wrapper">
                  <el-image
                    :src="baseImage || defaultProveImg"
                    fit="cover"
                    class="cert-image"
                    :preview-src-list="[baseImage || defaultProveImg]"
                    preview-teleported
                  >
                    <template #error>
                      <div class="cert-error-slot">
                        <el-icon><PictureFilled /></el-icon>
                        <span>暂无证书底图</span>
                      </div>
                    </template>
                  </el-image>

                  <div class="cert-watermark-overlay" v-if="!baseImage">
                    <span class="watermark-tag">官方示例模板</span>
                  </div>
                </div>

                <span class="cert-click-tip">点击证书图可全屏高清放大预览</span>
              </div>

              <!-- 右侧：配置操作面板与规则说明 -->
              <div class="certificate-controls">
                <div class="specs-card">
                  <h4 class="specs-title">证书图样设计建议</h4>
                  <ul class="specs-list">
                    <li>
                      <strong>推荐尺寸：</strong> 1080 × 1920 px
                      (竖版)，确保移动端全屏清晰度。
                    </li>
                    <li>
                      <strong>留白预留：</strong>
                      画面正中或靠下方请留出充足空白，供系统自动填入玩家昵称、总得分与游玩日期。
                    </li>
                    <li>
                      <strong>格式要求：</strong> 支持 JPG / PNG /
                      WEBP，体积不超过 5MB。
                    </li>
                  </ul>
                </div>

                <!-- 上传与快捷操作栏 -->
                <div class="action-card">
                  <div class="upload-btn-row">
                    <el-upload
                      ref="uploadRef"
                      class="single-uploader"
                      :action="UpdateApi"
                      :show-file-list="false"
                      :before-upload="beforeUpload"
                      :on-success="onSuccess"
                      :on-error="onError"
                    >
                      <el-button
                        type="primary"
                        size="large"
                        class="primary-upload-btn"
                        :loading="isUploading"
                      >
                        <el-icon><Upload /></el-icon>
                        {{ baseImage ? "更换证书底图" : "上传专属证书" }}
                      </el-button>
                    </el-upload>

                    <el-popconfirm
                      v-if="baseImage && baseImage !== defaultProveImg"
                      title="确认彻底移除该专属证书底图并恢复默认吗？"
                      confirm-button-text="确认移除"
                      cancel-button-text="取消"
                      confirm-button-type="danger"
                      @confirm="handleRemoveImage"
                    >
                      <template #reference>
                        <el-button
                          type="danger"
                          plain
                          size="large"
                          class="remove-btn"
                          :loading="isDeleting"
                        >
                          <el-icon><Delete /></el-icon>
                          重置为默认模板
                        </el-button>
                      </template>
                    </el-popconfirm>
                  </div>

                  <p class="upload-note">
                    <el-icon><InfoFilled /></el-icon>
                    上传新证书后系统将自动保存并覆盖原有模板
                  </p>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <!-- Tab 2: 调查问卷管理 -->
        <el-tab-pane label="研学调查问卷与反馈" name="second">
          <div class="tab-pane-content feedback-wrap">
            <feedback />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="zhanwei4"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ElMessage, ElNotification } from "element-plus";
import {
  Upload,
  Delete,
  PictureFilled,
  InfoFilled,
} from "@element-plus/icons-vue";
import feedback from "@/components/questionnaires/admin/feedback.vue";

export default defineComponent({
  name: "StudyProveManager",
  components: {
    feedback,
    Upload,
    Delete,
    PictureFilled,
    InfoFilled,
  },
  data() {
    return {
      activeName: "first",
      defaultProveImg:
        "https://nanchangfile.oss-cn-beijing.aliyuncs.com/prove.png",
      baseImage: "",
      game: null as any,
      isUploading: false,
      isDeleting: false,
    };
  },
  computed: {
    UpdateApi(): string {
      return process.env.VUE_APP_Update_API || "";
    },
  },
  mounted() {
    this.initGameData();
  },
  methods: {
    initGameData() {
      const currentGameId = this.$route.params.id;
      const gameList = this.$store.state.game?.games || [];
      const targetGame = gameList.find((item: any) => item.id == currentGameId);

      if (targetGame) {
        this.game = JSON.parse(JSON.stringify(targetGame));
        this.baseImage = targetGame.proveImg || "";
      }
    },

    async deleteRemoteFile(fileName: string): Promise<boolean> {
      if (!fileName) return true;
      try {
        const delFinished = await this.$store.dispatch("user/delFile", {
          fileName,
        });
        return delFinished === 1 || delFinished === true;
      } catch (error) {
        console.error("删除远程图片失败:", error);
        return false;
      }
    },

    beforeUpload(file: File): boolean {
      const isAllowed =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/webp";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isAllowed) {
        ElNotification.warning({
          message: "仅支持 JPG / PNG / WEBP 格式图片",
          offset: 100,
        });
        return false;
      }
      if (!isLt5M) {
        ElNotification.warning({
          message: "图片体积不可超过 5MB",
          offset: 100,
        });
        return false;
      }

      this.isUploading = true;
      return true;
    },

    async onSuccess(response: any) {
      this.isUploading = false;
      const newImageUrl = response?.data?.returnFileUrl;
      if (!newImageUrl) {
        ElMessage.error("未获取到图片上传地址");
        return;
      }

      try {
        const oldImage = this.game?.proveImg;
        if (oldImage && oldImage !== newImageUrl) {
          await this.deleteRemoteFile(oldImage);
        }

        this.game.proveImg = newImageUrl;
        this.baseImage = newImageUrl;

        const payloadGame = {
          ...this.game,
          carousel: "",
          tips:
            typeof this.game.tips === "string"
              ? this.game.tips
              : JSON.stringify(this.game.tips || {}),
        };

        await this.$store.dispatch("game/updateGame", {
          gameBean: payloadGame,
        });
        ElMessage.success("证书底图已成功上传并更新");
      } catch (error) {
        console.error("更新数据失败:", error);
        ElMessage.error("同步游戏配置失败");
      }
    },

    onError() {
      this.isUploading = false;
      ElMessage.error("图片上传失败，请稍后重试");
    },

    async handleRemoveImage() {
      if (!this.game?.proveImg) {
        this.baseImage = "";
        return;
      }

      this.isDeleting = true;
      try {
        await this.deleteRemoteFile(this.game.proveImg);
        this.game.proveImg = "";
        this.baseImage = "";

        const payloadGame = {
          ...this.game,
          carousel: "",
          tips:
            typeof this.game.tips === "string"
              ? this.game.tips
              : JSON.stringify(this.game.tips || {}),
        };

        await this.$store.dispatch("game/updateGame", {
          gameBean: payloadGame,
        });
        ElMessage.success("已恢复为默认官方证书模板");
      } catch (error) {
        ElMessage.error("重置证书失败");
      } finally {
        this.isDeleting = false;
      }
    },
  },
});
</script>

<style lang="less" scoped>
@primary-color: #5d5fef;
@primary-hover: #4b4de0;
@primary-light: #f0f2ff;
@text-main: #0f172a;
@text-sub: #475569;
@text-muted: #94a3b8;
@border-color: #e2e8f0;
@card-border: #f1f5f9;
@danger-color: #ef4444;

.zhanwei4 {
  height: 24px;
}

.study-prove-wrapper {
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

// 主白底卡片
.prove-container-card {
  background: #ffffff;
  border: 1px solid @card-border;
  border-radius: 16px;
  box-shadow: 0 4px 24px -2px rgba(15, 23, 42, 0.04);
  padding: 24px 32px 36px;
  box-sizing: border-box;

  @media (max-width: 640px) {
    padding: 16px 16px 24px;
  }
}

// 自定义现代化 Tabs 标签页
.modern-tabs {
  :deep(.el-tabs__nav-wrap::after) {
    height: 1px;
    background-color: @border-color;
  }

  :deep(.el-tabs__item) {
    font-size: 15px;
    font-weight: 600;
    color: @text-sub;
    padding: 0 20px;
    height: 48px;
    line-height: 48px;
    transition: all 0.2s ease;

    &.is-active {
      color: @primary-color;
      font-weight: 700;
    }
  }

  :deep(.el-tabs__active-bar) {
    background-color: @primary-color;
    height: 3px;
    border-radius: 2px;
  }
}

.tab-pane-content {
  padding-top: 16px;

  &.feedback-wrap {
    padding-top: 10px;
  }
}

// 顶部栏
.prove-header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid @border-color;
  margin-bottom: 28px;

  .header-left {
    display: flex;
    align-items: flex-start;
    gap: 12px;

    .indicator-bar {
      width: 4px;
      height: 20px;
      background: @primary-color;
      border-radius: 2px;
      margin-top: 2px;
    }

    .header-title {
      font-size: 16px;
      font-weight: 700;
      color: @text-main;
      margin: 0 0 4px 0;
    }

    .header-desc {
      font-size: 12.5px;
      color: @text-muted;
      margin: 0;
    }
  }

  .header-right {
    .ratio-badge {
      display: inline-block;
      font-size: 12px;
      font-weight: 600;
      color: @primary-color;
      background: @primary-light;
      padding: 4px 12px;
      border-radius: 20px;
      border: 1px solid #dce2ff;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}

// 双栏证书排版
.certificate-layout {
  display: flex;
  align-items: flex-start;
  gap: 48px;

  @media (max-width: 860px) {
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }
}

// 左侧：证书卡片展台
.certificate-stage {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;

  .cert-frame-wrapper {
    width: 250px;
    height: 420px; // 接近 9:16 证书黄金比例
    border-radius: 14px;
    overflow: hidden;
    position: relative;
    border: 6px solid #0f172a;
    box-shadow: 0 16px 36px -6px rgba(15, 23, 42, 0.2);
    background: #ffffff;
    cursor: zoom-in;
    transition: transform 0.25s ease, box-shadow 0.25s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 20px 42px -6px rgba(93, 95, 239, 0.25);
    }

    .cert-image {
      width: 100%;
      height: 100%;
      display: block;
    }

    .cert-error-slot {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
      color: @text-muted;
      font-size: 12px;
      background: #f8fafc;

      .el-icon {
        font-size: 32px;
      }
    }

    .cert-watermark-overlay {
      position: absolute;
      top: 12px;
      right: 12px;

      .watermark-tag {
        font-size: 11px;
        font-weight: 700;
        background: rgba(15, 23, 42, 0.65);
        color: #ffffff;
        backdrop-filter: blur(4px);
        padding: 3px 8px;
        border-radius: 4px;
      }
    }
  }

  .cert-click-tip {
    font-size: 11.5px;
    color: @text-muted;
    margin-top: 12px;
  }
}

// 右侧：说明与按钮面板
.certificate-controls {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  .specs-card {
    background: #f8fafc;
    border: 1px solid @border-color;
    border-radius: 12px;
    padding: 20px 24px;

    .specs-title {
      margin: 0 0 12px 0;
      font-size: 14px;
      font-weight: 700;
      color: @text-main;
    }

    .specs-list {
      margin: 0;
      padding-left: 18px;
      font-size: 12.5px;
      color: @text-sub;
      line-height: 1.8;

      strong {
        color: @text-main;
      }
    }
  }

  .action-card {
    background: #ffffff;
    border: 1px solid @border-color;
    border-radius: 12px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 14px;

    .upload-btn-row {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 16px;

      .single-uploader {
        display: inline-block;
      }

      .primary-upload-btn {
        height: 44px;
        padding: 0 24px;
        border-radius: 8px;
        font-weight: 600;
        background-color: @primary-color;
        border-color: @primary-color;
        box-shadow: 0 4px 12px rgba(93, 95, 239, 0.25);
        transition: all 0.2s ease;

        .el-icon {
          margin-right: 6px;
        }

        &:hover {
          background-color: @primary-hover;
          border-color: @primary-hover;
          transform: translateY(-1px);
          box-shadow: 0 6px 16px rgba(93, 95, 239, 0.35);
        }
      }

      .remove-btn {
        height: 44px;
        border-radius: 8px;
        font-weight: 500;
        border-color: #fecaca;
        background-color: #fef2f2;
        color: @danger-color;

        .el-icon {
          margin-right: 6px;
        }

        &:hover {
          background-color: #fee2e2;
          border-color: #fca5a5;
        }
      }
    }

    .upload-note {
      margin: 0;
      font-size: 12px;
      color: @text-muted;
      display: flex;
      align-items: center;
      gap: 6px;

      .el-icon {
        color: @primary-color;
        font-size: 14px;
      }
    }
  }
}
</style>
